import { z } from "zod";

import { extractTranslations } from "./extract";
import { getCmsAssetUrl } from "./utils";

export const blockSchema = z.object({
  id: z.number().positive(),
  collection: z.string(),
  item: z.preprocess(
    extractTranslations,
    z
      .object({
        translations: z.object({}).passthrough(),
      })
      .passthrough(),
  ),
});

export const articleBlockSchema = z.object({
  id: z.number().positive(),
  collection: z.string().min(3),
  item: z
    .object({
      aside: z.boolean().optional(),
    })
    .passthrough(),
});

export const articleBlocksSchema = z.array(articleBlockSchema);

export const blocksSchema = z.array(blockSchema);

export const imageSchema = z
  .object({
    filenameDisk: z.string(),
    title: z.string(),
    width: z.number().positive().nullable().default(null),
    height: z.number().positive().nullable().default(null),
  })
  .transform(({ filenameDisk, title, ...rest }) => ({
    ...rest,
    title,
    url: getCmsAssetUrl(filenameDisk),
  }));

export const seoSchema = z.object({
  title: z.string().optional().nullable(),
  description: z.string().optional().nullable(),
  canonicalUrl: z.string().optional().nullable(),
  ogImage: imageSchema.optional().nullable(),
  noIndex: z.boolean().default(false),
  noFollow: z.boolean().default(false),
});

const bannerTypeSchema = z.enum(["banner_background_image", "banner_side_image"]);

export const sideImageSchema = z.object({
  bannerType: bannerTypeSchema,
  image: imageSchema,
  title: z.string(),
  description: z.string(),
  buttonText: z.string(),
  buttonUrl: z.string(),
  imagePosition: z.enum(["left", "right"]),
  backgroundColor: z.enum(["blue", "white-linen"]),
  buttonVariant: z.enum(["primary", "secondary", "tertiary", "destructive", "ghost", "link"]),
});

export const backgroundImageSchema = z.object({
  bannerType: bannerTypeSchema,
  title: z.string(),
  description: z.string(),
  buttonText: z.string(),
  buttonUrl: z.string(),
  imageSmall: imageSchema,
  imageLarge: imageSchema,
});

export const promoBannerSchema = z
  .array(
    z.object({
      item: z.union([backgroundImageSchema, sideImageSchema]),
    }),
  )
  .optional();
